document.addEventListener('DOMContentLoaded', function(){ 
  const hamburger = document.querySelector('.hamburger');
  const mobileSlideOutMenu = document.getElementById('mobile-slide-out-menu');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  const mobileCloseButton = document.querySelector('.close-hamburger');

  hamburger.addEventListener('click', function () {
    mobileSlideOutMenu.style.display = 'flex';
    mobileMenuOverlay.style.display = 'block';
    hamburger.innerHTML = 'X';
  });

  mobileMenuOverlay.addEventListener('click', function () {
    mobileSlideOutMenu.style.display = 'none';
    mobileMenuOverlay.style.display = 'none';
    hamburger.innerHTML = `
      <div></div>
      <div></div>
      <div></div>
    `;
  });

  mobileMenuOverlay.addEventListener('click', function () {
    mobileSlideOutMenu.style.display = 'none';
    mobileMenuOverlay.style.display = 'none';
    hamburger.innerHTML = `
      <div></div>
      <div></div>
      <div></div>
    `;
  });

  mobileCloseButton.addEventListener('click', function () {
    mobileSlideOutMenu.style.display = 'none';
    mobileMenuOverlay.style.display = 'none';
    hamburger.innerHTML = `
      <div></div>
      <div></div>
      <div></div>
    `;
  });

  // Promo video
  const promoVideoBtn = document.getElementById('preview-video');
  promoVideoBtn.addEventListener('click', function (e) {  
    const link = promoVideoBtn.dataset.videoLink;
    Fancybox.show([
      {
        src: link,
        width: 1366,
        height: 768,
      },
    ]); 
  });
  // Open popup
  const fancyboxLinks = document.querySelectorAll('[data-fancybox]');
  fancyboxLinks.forEach(link => {    
    link.addEventListener('click', (event) => {     
      Fancybox.show([{ src: link.dataset.src, type: "clone" }]);
    });
  });


  // Smooth scroll to section
  const scrollLinks = document.querySelectorAll('a');
  scrollLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      const href = event.currentTarget.getAttribute('href');

      // Проверяем, содержит ли ссылка хэштег
      if (href.startsWith('#')) {
        event.preventDefault();
        const targetId = href;
        const targetElement = document.querySelector(targetId);
        targetElement.scrollIntoView({  behavior: 'smooth', block: 'center', inline: 'center' });
      }
    });
  });

  const firstBlock = document.querySelector('#hero').firstElementChild;
  const scrollTopBtn = document.querySelector('#scrollTop');
  const footer = document.querySelector('#footer');
  scrollTopBtn.addEventListener('click', (event) => {   
    event.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'});
  });

  window.onscroll = function () {
    const blockHeight = firstBlock.clientHeight;
    const blockFromTop = firstBlock.getBoundingClientRect().top;

    const containerWidth = footer.querySelector(".container").offsetWidth;
    const screenWidth = window.innerWidth;
    const marginRight = screenWidth - containerWidth - 40 - 50;
    if (blockFromTop < -blockHeight) {
      // scrollTopBtn.style.display = 'block';
      scrollTopBtn.style.pointerEvents = 'auto';
      scrollTopBtn.style.opacity = '1';
    } else {
      // scrollTopBtn.style.display = 'none';
      scrollTopBtn.style.pointerEvents = 'none';
      scrollTopBtn.style.opacity = '0';
    }
    
      scrollTopBtn.style.right = marginRight + 'px';
      scrollTopBtn.style.bottom = '20px';
    // scrollTopBtn.style.bottom = '20px';
  };
  
});